// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2HEQk","title":"ClientCherryInfo_title__3rW7M","itemText":"ClientCherryInfo_itemText__GPjHH"};